function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5077_6729)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.6665 0V2.66667",
  stroke: "#2F7067",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 6.33325H16",
  stroke: "#2F7067",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.89994 1.56665L6.7666 3.43332",
  stroke: "#2F7067",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5669 9.2334L14.4336 11.1001",
  stroke: "#2F7067",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5669 3.43332L14.4336 1.56665",
  stroke: "#2F7067",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.30992 5.29527L10.7241 6.70947L1.76752 15.6661L0.353321 14.2519L9.30992 5.29527Z",
  fill: "white",
  stroke: "#2F7067",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 7.5L8.5 9",
  stroke: "#2F7067",
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5077_6729"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "matrix(-1 0 0 1 16 0)"
})));

var SvgMagicWand = function SvgMagicWand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagicWand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magic-wand.e533a060.svg";
export { ForwardRef as ReactComponent };